<div class="login_wrapper">
  <div class="login_elements">
    <div class="login_logo">Excelsior</div>
    <div class="login_message">404 Page Not Found</div>
  </div>
</div>